import SupportItem from "./support-item";

class SupportItemsForm {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this.init();
        }
    }

    init() {
        this.$supportItems = this.$el.find('.list-supports .support-item');
        this.$nextStepButton = this.$el.find('.supports-command-form__next-step-button');
        this.$supportsListStep = this.$el.find('.supports-command-form__step.list-supports');
        this.$cartStep = this.$el.find('.supports-command-form__step.cart');
        this.$confirmationStep = this.$el.find('.supports-command-form__step.confirmation');
        this.$form = this.$el.find('.list-supports__dummy-form');
        this.$orderedSupportsField = this.$form.find('input[name="supports"]');
        this.$formErrorsList = this.$el.find('.list-supports__address-form-error');
        this.$cartList = this.$el.find('.list-supports__cart-list');
        this.$backButton = this.$el.find('.supports-command-form__back-button');
        this.$cf7Form = this.$el.find('.wpcf7');

        this.supportItems = [];

        if(this.$supportItems.length && this.$nextStepButton.length) {
            this._createSupportItems();
            this._bindEvents();

            this.$supportsListStep.addClass('supports-command-form__step--active');
        }
    }

    _bindEvents() {
        this.validateSupportItemsFn = this._validateSupportItems.bind(this);
        this.goToCartStepFn = this._goToCartStep.bind(this);
        this.goToSupportsListStepFn = this._goToSupportsListStep.bind(this);
        this.onCF7FormErrorFn = this._onCF7FormError.bind(this);
        this.onCF7MailSentFn = this._onCF7MailSent.bind(this);
        this.onLoadFailFn = this._onLoadFail.bind(this);
        this.lockLoadingFn = this._lockLoading.bind(this);
        this.unlockLoadingFn = this._unlockLoading.bind(this);

        this.$nextStepButton.on('click', this.goToCartStepFn);
        this.$backButton.on('click', this.goToSupportsListStepFn);

        if(this.$cf7Form.length) {
            this.$cf7Form.find('input').on('focus', (e) => { e.preventDefault(); return false; });
            this.$cf7Form[0].addEventListener('wpcf7invalid', this.onCF7FormErrorFn);
            this.$cf7Form[0].addEventListener('wpcf7mailsent', this.onCF7MailSentFn);
            // this.$cf7Form[0].addEventListener('wpcf7submit', this.onCF7MailSentFn);
        }
    }

    _createSupportItems() {
        if(this.$supportItems.length) {
            this.$supportItems.each((index, el) => {
                const $el = $(el);

                this.supportItems.push({
                    $el: $el,
                    instance: new SupportItem($el)
                });
            });
        }
    }

    _validateSupportItems() {
        let areValid = true;
        let cartIsNotEmpty = false;

        this.supportItems.forEach((supportItem) => {
            supportItem.instance.validate();

            if(!supportItem.instance.isValid) {
                areValid = false;
            }

            if(supportItem.instance.getValue() > 0) {
                cartIsNotEmpty = true;
            }
        });

        return areValid && cartIsNotEmpty;
    }

    _validateFormData(callback) {
        console.log('_validateFormData');
        const formData = this._getAjaxData();
        const request = $.ajax({
            url: cp.ajax_url,
            type: 'post',
            data: formData,
            dataType: 'json',
            beforeSend: this.lockLoadingFn
        });

        request.done(callback);
        request.fail(this.onLoadFailFn);
        request.always(this.unlockLoadingFn);
    }

    _getAjaxData() {
        const formData = this.$form.serializeArray();
        let dataToSend = {};

        formData.forEach((field) => {
            dataToSend[field.name] = field.value;
        });

        return {
            action: 'validate_supports_data',
            ...dataToSend,
            _wpnonce_supports_form: cp._wpnonce_supports_form
        };
    }

    _lockLoading() {
        this.$nextStepButton.addClass('loading');
    }

    _unlockLoading() {
        this.$nextStepButton.removeClass('loading');
    }

    _onLoadFail(jqXHR, textStatus, errorThrown) {
        console.log('onLoadFail', jqXHR, textStatus, errorThrown);
        this.$formErrorsList.empty();
        this.$formErrorsList.append('<li>Une erreur s\'est produite. Merci de bien vouloir réessayer plus tard.</li>')

        $('html, body').animate({
            scrollTop: this.$formErrorsList.offset().top - ($('.site-header').height() + 50)
        }, 300);
    }

    _onCF7FormError(e) {
        console.log('_onCF7FormError', e);
        this.$formErrorsList.empty();
        this.$formErrorsList.append('<li>Une erreur s\'est produite. Merci de bien vouloir vérifier les données du formulaire.</li>');

        this._goToSupportsListStep();

        $('html, body').animate({
            scrollTop: this.$formErrorsList.offset().top - ($('.site-header').height() + 50)
        }, 300);
    }

    _onCF7MailSent(e) {
        console.log('_onCF7MailSent', e);
        this._goToConfirmationStep();
    }

    _copyDataToCF7Form() {
        const formData = this.$form.serializeArray();
        console.log('formData:', formData);

        formData.forEach((field) => {
            const cf7Field = this.$cf7Form.find(`input[name="${field.name}"]`);

            if(cf7Field.length) {
                cf7Field.val(field.value);
            }
        });
    }

    _resetCF7Form() {
        const $cf7Fields = this.$cf7Form.find('input:not([type="submit"]):not([type="hidden"]),input[name="supports"]');

        if($cf7Fields.length) {
            $cf7Fields.val('');
        }
    }

    _resetFormValidation() {
        this.$formErrorsList.empty();

        const $erroredFields = this.$form.find('.has-error');

        if($erroredFields.length) {
            $erroredFields.removeClass('has-error');
        }
    }

    _goToSupportsListStep(e) {
        if(e) {
            e.preventDefault();
        }

        this.$supportsListStep.addClass('supports-command-form__step--active');
        this.$cartStep.removeClass('supports-command-form__step--active');
        this._emptyCart();
        this._resetCF7Form();
        this._emptyOrderedSupporsList();
    }

    _goToCartStep(e) {
        e.preventDefault();

        if(!this.$nextStepButton.hasClass('loading')) {

            this._resetFormValidation();

            const supportItemsvalidationState = this._validateSupportItems();
            console.log('supportItemsvalidationState', supportItemsvalidationState);
            if(supportItemsvalidationState) {
                this._populateOrderedSupporsList();

                this._validateFormData((response) => {
                    console.log('data:', response);
                    if(response.data.is_valid) {
                        this._populateCart();
                        this._copyDataToCF7Form();
                        this.$supportsListStep.removeClass('supports-command-form__step--active');
                        this.$cartStep.addClass('supports-command-form__step--active');

                        $('html, body').animate({
                            scrollTop: this.$cartStep.offset().top - ($('.site-header').height() + 50)
                        }, 300);
                    }
                    else {
                        Object.keys(response.data.errors).forEach((key) => {
                            if(response.data.errors[key] && response.data.errors[key].length) {
                                const $field = this.$form.find(`[name=${key}]`);

                                if($field.length) {
                                    $field.addClass('has-error');
                                    response.data.errors[key].forEach((error) => {
                                        this.$formErrorsList.append(`<li>${error}</li>`);
                                    });
                                }
                            }
                        });

                        $('html, body').animate({
                            scrollTop: this.$formErrorsList.offset().top - ($('.site-header').height() + 50)
                        }, 300);
                    }
                });
            }
            else {
                this.$formErrorsList.append('<li>Votre panier est vide. Veuillez commander au moins un support.</li>');
                $('html, body').animate({
                    scrollTop: this.$formErrorsList.offset().top - ($('.site-header').height() + 50)
                }, 300);
            }
        }
    }

    _goToConfirmationStep(e) {
        this.$cartStep.removeClass('supports-command-form__step--active');
        this.$confirmationStep.addClass('supports-command-form__step--active');
        $('html, body').animate({
            scrollTop: this.$confirmationStep.offset().top - ($('.site-header').height() + 50)
        }, 300);
    }

    _populateCart() {
        let cartTpl = '';

        this.supportItems.forEach((supportItem) => {
            supportItem.instance.validate();

            if(supportItem.instance.isValid && supportItem.instance.getValue() > 0) {
                cartTpl += `
                    <div class="support-item">
                        <div class="support-item__img">
                            <img class="alignnone" src="${supportItem.instance.image}" alt="">
                        </div>
                        <div class="support-item__content">
                            <h3 class="heading">${supportItem.instance.title}</h3>
                            <span class="support-item__description">${supportItem.instance.details}</span>
                            <span class="support-item__description">${supportItem.instance.quantityDescription}</span>
                            <p class="support-item__quantity-cart">
                                <strong>Quantité</strong>
                                <span class="">${supportItem.instance.getValue()}</span>
                            </p>
                        </div>
                    </div>
                `;
            }
        });

        if(cartTpl.length) {
            this.$cartList.append(cartTpl);
        }
    }

    _emptyCart() {
        const $itemsToRemove = this.$cartList.find('.support-item');
        if($itemsToRemove.length) {
            $itemsToRemove.remove();
        }
    }

    _populateOrderedSupporsList() {
        if(this.supportItems.length) {
            console.log(this.supportItems);
            let orderedSupportsFieldValue = {};

            this.supportItems.forEach((supportItem) => {
                orderedSupportsFieldValue[supportItem.instance.id] = supportItem.instance.getValue();
            });

            this.$orderedSupportsField.val(JSON.stringify(orderedSupportsFieldValue));
        }

    }

    _emptyOrderedSupporsList() {
        this.$orderedSupportsField.val('');
    }
}

export default SupportItemsForm;
